import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'roma-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  host: {
    '[class.roma-pagination--alt]': 'useAltStyle',
  },
})
export class PaginationComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() maxVisible = 6;
  @Input() useAltStyle = false;

  @Output() pageChange = new EventEmitter<number>();

  visiblePages: number[] = [];

  ngOnChanges() {
    this.updateVisiblePages();
  }

  updateVisiblePages() {
    const pages: number[] = [];

    if (this.totalPages <= this.maxVisible) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      let start = this.currentPage - 2;
      let end = this.currentPage + 2;

      if (start <= 2) {
        start = 2;
        end = this.maxVisible - 1;
      }

      if (end >= this.totalPages - 1) {
        end = this.totalPages - 1;
        start = Math.max(2, this.totalPages - (this.maxVisible - 2));
      }

      if (start > 2) {
        pages.push(-1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < this.totalPages - 1) {
        pages.push(-2);
      }

      pages.push(this.totalPages);
    }

    this.visiblePages = pages;
  }

  goToPage(page: number) {
    if (page > 0 && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }
}
